// Typical overall dims per size class (inches).
const OVERALL_BY_SIZE_CLASS = {
    city_compact: { lengthIn: 160, widthIn: 68, heightIn: 59, wheelbaseIn: 99 },
    sedan: { lengthIn: 190, widthIn: 72, heightIn: 57, wheelbaseIn: 110 },
    hatch_wagon: { lengthIn: 172, widthIn: 70, heightIn: 58, wheelbaseIn: 104 },
    coupe_sports: { lengthIn: 180, widthIn: 73, heightIn: 53, wheelbaseIn: 107 },
    crossover_mid_suv: { lengthIn: 185, widthIn: 75, heightIn: 66, wheelbaseIn: 109 },
    full_suv: { lengthIn: 205, widthIn: 80, heightIn: 75, wheelbaseIn: 120 },
    pickup_truck: { lengthIn: 232, widthIn: 80, heightIn: 77, wheelbaseIn: 146 },
    van_commercial: { lengthIn: 235, widthIn: 81, heightIn: 84, wheelbaseIn: 148 },
    exotic_supercar: { lengthIn: 180, widthIn: 78, heightIn: 47, wheelbaseIn: 105 },
};
const ARCHETYPE_BY_SIZE_CLASS = {
    city_compact: 'hatch',
    sedan: 'sedan',
    hatch_wagon: 'hatch',
    coupe_sports: 'coupe',
    crossover_mid_suv: 'suv',
    full_suv: 'suv',
    pickup_truck: 'pickup',
    van_commercial: 'van',
    exotic_supercar: 'coupe',
};
const DOORS_BY_SIZE_CLASS = {
    city_compact: 4,
    sedan: 4,
    hatch_wagon: 4,
    coupe_sports: 2,
    crossover_mid_suv: 4,
    full_suv: 4,
    pickup_truck: 4,
    van_commercial: 4,
    exotic_supercar: 2,
};
const SIDE_PROFILES = {
    sedan: {
        points: [
            { xFrac: 0, yFrac: 0 },
            { xFrac: 0.04, yFrac: 0.46 },
            { xFrac: 0.08, yFrac: 0.4 },
            { xFrac: 0.3, yFrac: 0.34 },
            { xFrac: 0.38, yFrac: 0.16 },
            { xFrac: 0.62, yFrac: 0.14 },
            { xFrac: 0.72, yFrac: 0.3 },
            { xFrac: 0.9, yFrac: 0.34 },
            { xFrac: 0.97, yFrac: 0.44 },
            { xFrac: 1, yFrac: 0 },
        ],
        glassTopFrac: 0.18,
        glassFrontXFrac: { start: 0.32, end: 0.5 },
        glassRearXFrac: { start: 0.5, end: 0.68 },
    },
    coupe: {
        points: [
            { xFrac: 0, yFrac: 0 },
            { xFrac: 0.04, yFrac: 0.42 },
            { xFrac: 0.08, yFrac: 0.36 },
            { xFrac: 0.32, yFrac: 0.3 },
            { xFrac: 0.42, yFrac: 0.1 },
            { xFrac: 0.58, yFrac: 0.09 },
            { xFrac: 0.72, yFrac: 0.28 },
            { xFrac: 0.88, yFrac: 0.32 },
            { xFrac: 0.96, yFrac: 0.42 },
            { xFrac: 1, yFrac: 0 },
        ],
        glassTopFrac: 0.12,
        glassFrontXFrac: { start: 0.36, end: 0.7 },
        glassRearXFrac: null,
    },
    hatch: {
        points: [
            { xFrac: 0, yFrac: 0 },
            { xFrac: 0.05, yFrac: 0.44 },
            { xFrac: 0.09, yFrac: 0.38 },
            { xFrac: 0.3, yFrac: 0.34 },
            { xFrac: 0.4, yFrac: 0.16 },
            { xFrac: 0.68, yFrac: 0.15 },
            { xFrac: 0.86, yFrac: 0.28 },
            { xFrac: 0.94, yFrac: 0.36 },
            { xFrac: 0.98, yFrac: 0.46 },
            { xFrac: 1, yFrac: 0 },
        ],
        glassTopFrac: 0.18,
        glassFrontXFrac: { start: 0.32, end: 0.48 },
        glassRearXFrac: { start: 0.48, end: 0.68 },
    },
    suv: {
        points: [
            { xFrac: 0, yFrac: 0 },
            { xFrac: 0.04, yFrac: 0.36 },
            { xFrac: 0.08, yFrac: 0.3 },
            { xFrac: 0.26, yFrac: 0.26 },
            { xFrac: 0.34, yFrac: 0.1 },
            { xFrac: 0.74, yFrac: 0.08 },
            { xFrac: 0.88, yFrac: 0.24 },
            { xFrac: 0.96, yFrac: 0.3 },
            { xFrac: 0.98, yFrac: 0.38 },
            { xFrac: 1, yFrac: 0 },
        ],
        glassTopFrac: 0.12,
        glassFrontXFrac: { start: 0.36, end: 0.52 },
        glassRearXFrac: { start: 0.52, end: 0.84 },
    },
    pickup: {
        points: [
            { xFrac: 0, yFrac: 0 },
            { xFrac: 0.04, yFrac: 0.34 },
            { xFrac: 0.06, yFrac: 0.3 },
            { xFrac: 0.22, yFrac: 0.24 },
            { xFrac: 0.3, yFrac: 0.08 },
            { xFrac: 0.46, yFrac: 0.07 },
            { xFrac: 0.5, yFrac: 0.3 },
            { xFrac: 0.52, yFrac: 0.42 },
            { xFrac: 0.94, yFrac: 0.42 },
            { xFrac: 0.97, yFrac: 0.46 },
            { xFrac: 1, yFrac: 0 },
        ],
        glassTopFrac: 0.1,
        glassFrontXFrac: { start: 0.32, end: 0.46 },
        glassRearXFrac: null,
    },
    van: {
        points: [
            { xFrac: 0, yFrac: 0 },
            { xFrac: 0.02, yFrac: 0.52 },
            { xFrac: 0.08, yFrac: 0.34 },
            { xFrac: 0.14, yFrac: 0.14 },
            { xFrac: 0.17, yFrac: 0.06 },
            { xFrac: 0.92, yFrac: 0.05 },
            { xFrac: 0.97, yFrac: 0.1 },
            { xFrac: 0.99, yFrac: 0.3 },
            { xFrac: 1, yFrac: 0 },
        ],
        glassTopFrac: 0.1,
        glassFrontXFrac: { start: 0.19, end: 0.35 },
        glassRearXFrac: null,
    },
};
// Wheel radius as a fraction of overall height, per archetype - close to
// real tyre sizes (roughly 26in diameter for a sedan, 30-32in for a
// pickup/van, given typical overall heights).
const WHEEL_RADIUS_FRAC = {
    sedan: 0.165,
    coupe: 0.165,
    hatch: 0.165,
    suv: 0.18,
    pickup: 0.2,
    van: 0.15,
};
// Sill/rocker line height, as a fraction of overall height ABOVE THE GROUND
// - this is the body's own lowest edge between the wheels. Well below the
// wheel-arch cut-out so the body visibly overlaps the top of each tyre.
const SILL_FRAC_FROM_GROUND = {
    sedan: 0.14,
    coupe: 0.14,
    hatch: 0.14,
    suv: 0.15,
    pickup: 0.2,
    van: 0.2,
};
// Beltline (bottom of the side/DLO glass) height, as a fraction of overall
// height above the ground. Doors run from the sill up to this line.
const BELTLINE_FRAC_FROM_GROUND = {
    sedan: 0.58,
    coupe: 0.58,
    hatch: 0.58,
    suv: 0.6,
    pickup: 0.66,
    van: 0.64,
};
/** The sill/rocker line's y in inches from the TOP of the view box. */
function sillY(archetype, heightIn) {
    return heightIn * (1 - SILL_FRAC_FROM_GROUND[archetype]);
}
// Front/rear bumper line height, as a fraction of overall height above the
// ground - a straight line (no wheel-arch notches: seen head-on, the tyres
// stand in front of/behind the bumper, they do not cut into it).
const BUMPER_FRAC_FROM_GROUND = {
    sedan: 0.1,
    coupe: 0.1,
    hatch: 0.1,
    suv: 0.14,
    pickup: 0.14,
    van: 0.14,
};
/** The front/rear bumper line's y in inches from the TOP of the view box. */
function bumperY(archetype, heightIn) {
    return heightIn * (1 - BUMPER_FRAC_FROM_GROUND[archetype]);
}
/** The beltline's y in inches from the TOP of the view box. */
function beltlineY(archetype, heightIn) {
    return heightIn * (1 - BELTLINE_FRAC_FROM_GROUND[archetype]);
}
// ---------------------------------------------------------------------------
// Features - headlight/tail-light/grille/plate geometry. Measured (AI
// measurement) when available on the template; otherwise these archetype
// defaults, sized as sensible real-world proportions. Treated as exclusion
// zones exactly like glass - see lightsBandFor() below.
// ---------------------------------------------------------------------------
// Headlight/tail-light/grille sized as a fraction of the half-width, kept
// well inboard of the fender edge (outer edge at most ~0.55 of the half
// width) so there is still real corner/fender sheet metal outboard of them
// for a front_bumper_corner panel - matching a real car's proportions.
const DEFAULT_FEATURES_BY_ARCHETYPE = {
    sedan: {
        headlight: { widthIn: 11, heightIn: 8, centerFromCenterlineIn: 15, bottomFromGroundIn: 26 },
        taillight: { widthIn: 9, heightIn: 7, centerFromCenterlineIn: 16, bottomFromGroundIn: 24 },
        grille: { widthIn: 15, heightIn: 9, bottomFromGroundIn: 22 },
        frontPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 15 },
        rearPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 15 },
    },
    coupe: {
        headlight: { widthIn: 11, heightIn: 7, centerFromCenterlineIn: 15, bottomFromGroundIn: 24 },
        taillight: { widthIn: 10, heightIn: 6, centerFromCenterlineIn: 16, bottomFromGroundIn: 22 },
        grille: { widthIn: 15, heightIn: 8, bottomFromGroundIn: 20 },
        frontPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 13 },
        rearPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 13 },
    },
    hatch: {
        headlight: { widthIn: 11, heightIn: 8, centerFromCenterlineIn: 14, bottomFromGroundIn: 27 },
        taillight: { widthIn: 9, heightIn: 10, centerFromCenterlineIn: 15, bottomFromGroundIn: 24 },
        grille: { widthIn: 15, heightIn: 8, bottomFromGroundIn: 23 },
        frontPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 16 },
        rearPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 16 },
    },
    suv: {
        headlight: { widthIn: 12, heightIn: 9, centerFromCenterlineIn: 16, bottomFromGroundIn: 32 },
        taillight: { widthIn: 11, heightIn: 12, centerFromCenterlineIn: 17, bottomFromGroundIn: 28 },
        grille: { widthIn: 17, heightIn: 10, bottomFromGroundIn: 28 },
        frontPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 18 },
        rearPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 18 },
    },
    pickup: {
        headlight: { widthIn: 12, heightIn: 9, centerFromCenterlineIn: 17, bottomFromGroundIn: 34 },
        taillight: { widthIn: 8, heightIn: 14, centerFromCenterlineIn: 20, bottomFromGroundIn: 30 },
        grille: { widthIn: 18, heightIn: 12, bottomFromGroundIn: 30 },
        frontPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 20 },
        rearPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 20 },
    },
    van: {
        headlight: { widthIn: 12, heightIn: 9, centerFromCenterlineIn: 17, bottomFromGroundIn: 34 },
        // Tall vertical strip nearer the rear corner than a car's, not a wide
        // low rectangle - still leaves a narrow corner panel outboard of it.
        taillight: { widthIn: 6, heightIn: 22, centerFromCenterlineIn: 28, bottomFromGroundIn: 24 },
        grille: { widthIn: 18, heightIn: 10, bottomFromGroundIn: 30 },
        frontPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 20 },
        rearPlate: { widthIn: 12, heightIn: 6, bottomFromGroundIn: 20 },
    },
};
function getFeatures(template) {
    return template.features ?? DEFAULT_FEATURES_BY_ARCHETYPE[template.archetype];
}
// Wheel-arch radius as a multiple of the wheel radius - the cut-out runs
// from the (low) sill line up over the tyre and back down, well clear of
// the tyre itself.
const ARCH_RADIUS_MULT = 1.14;
// General clearance (inches) kept between a panel's edge and any glass,
// wheel or arch boundary it must not cross.
const PANEL_SAFETY_IN = 1.3;
const ROCKER_THICKNESS_IN = 2;
function frontOverhangFrac(archetype) {
    return archetype === 'pickup' || archetype === 'van' ? 0.4 : 0.45;
}
/** Wheel centers/radius for a side view, in inches within the view box.
 * `mirror` places the front wheel near x=L (passenger side), matching the
 * mirrored body profile. */
function sideWheels(template, mirror) {
    const { lengthIn: L, heightIn: H, wheelbaseIn } = template.overall;
    const r = WHEEL_RADIUS_FRAC[template.archetype] * H;
    const frontOverhangIn = frontOverhangFrac(template.archetype) * (L - wheelbaseIn);
    const frontX = mirror ? L - frontOverhangIn : frontOverhangIn;
    const rearX = mirror ? frontX - wheelbaseIn : frontX + wheelbaseIn;
    const cy = H - r;
    return [
        { cx: frontX, cy, r },
        { cx: rearX, cy, r },
    ];
}
function pointsToPath(points, close) {
    if (points.length === 0)
        return '';
    const first = points[0];
    if (!first)
        return '';
    let d = `M ${first.x.toFixed(2)} ${first.y.toFixed(2)}`;
    for (const p of points.slice(1))
        d += ` L ${p.x.toFixed(2)} ${p.y.toFixed(2)}`;
    if (close)
        d += ' Z';
    return d;
}
/** Traces a horizontal baseline from xStart to xEnd (ascending x), dipping
 * up into a rounded arch cut-out over each wheel whose arch intersects the
 * baseline - the shared technique behind both the side-view rocker line and
 * the front/rear-view ground line. All points are on straight segments
 * (no SVG curve commands) so the resulting path can be hit-tested directly
 * by sampling its vertices. */
function traceBaselineWithArches(baselineY, xStart, xEnd, wheels, archRadiusMult, steps = 12) {
    const relevant = wheels
        .filter((w) => w.cx > xStart && w.cx < xEnd && w.cy - w.r * archRadiusMult < baselineY)
        .sort((a, b) => a.cx - b.cx);
    const points = [{ x: xStart, y: baselineY }];
    for (const wheel of relevant) {
        const archR = wheel.r * archRadiusMult;
        const dyc = baselineY - wheel.cy;
        const halfChord = Math.sqrt(Math.max(0, archR * archR - dyc * dyc));
        const leftX = Math.max(xStart, wheel.cx - halfChord);
        const rightX = Math.min(xEnd, wheel.cx + halfChord);
        if (rightX <= leftX)
            continue;
        points.push({ x: leftX, y: baselineY });
        for (let i = 1; i < steps; i++) {
            const x = leftX + ((rightX - leftX) * i) / steps;
            const y = wheel.cy - Math.sqrt(Math.max(0, archR * archR - (x - wheel.cx) ** 2));
            points.push({ x, y: Math.min(y, baselineY) });
        }
        points.push({ x: rightX, y: baselineY });
    }
    points.push({ x: xEnd, y: baselineY });
    return points;
}
/** The wheel-arch cut-out's own y at a given x (the same curve traced by
 * traceBaselineWithArches), or Infinity outside the arch's chord where the
 * cut-out does not apply. */
function archCurveYAt(wheel, archRadiusMult, x) {
    const archR = wheel.r * archRadiusMult;
    const dx = x - wheel.cx;
    if (Math.abs(dx) >= archR)
        return Infinity;
    return wheel.cy - Math.sqrt(Math.max(0, archR * archR - dx * dx));
}
// ---------------------------------------------------------------------------
// One panel = one real body panel. A panel whose true edge follows a curve
// (a fender around a wheel arch, a sloped hood/trunk edge) is emitted as a
// single sampled polygon rather than many small rects; a panel that is
// already an exact rectangle is emitted as a plain x/y/w/h with no points.
// ---------------------------------------------------------------------------
/** Builds one polygon panel spanning [x0,x1], with its top edge sampled
 * from `topFn(x)` and its bottom edge from `bottomFn(x)` (both in the same
 * canonical, unmirrored coordinate space as the rest of this file). The two
 * curves are clamped against each other at every sample so the polygon can
 * never self-intersect: where the body genuinely has no height to give
 * (e.g. right at a pinched nose/tail tip), that sample just collapses to a
 * hairline instead of flipping top below bottom. Returns null if the
 * resulting shape has no real area. */
function buildPolygonPanel(key, label, view, x0, x1, topFn, bottomFn, samples = 20) {
    if (x1 - x0 <= 0.5)
        return null;
    const xs = [];
    for (let i = 0; i <= samples; i++)
        xs.push(x0 + ((x1 - x0) * i) / samples);
    const tops = xs.map(topFn);
    const bottoms = xs.map(bottomFn);
    for (let i = 0; i < xs.length; i++) {
        const top = tops[i];
        const bottom = bottoms[i];
        if (top === undefined || bottom === undefined)
            continue;
        if (bottom - top < 0.04) {
            const mid = (top + bottom) / 2;
            tops[i] = mid - 0.02;
            bottoms[i] = mid + 0.02;
        }
    }
    const points = [];
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for (let i = 0; i < xs.length; i++) {
        const x = xs[i];
        const y = tops[i];
        if (x === undefined || y === undefined)
            continue;
        points.push([x, y]);
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    for (let i = xs.length - 1; i >= 0; i--) {
        const x = xs[i];
        const y = bottoms[i];
        if (x === undefined || y === undefined)
            continue;
        points.push([x, y]);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    if (maxX - minX <= 0.5 || maxY - minY <= 0.5)
        return null;
    return { key, label, view, x: minX, y: minY, w: maxX - minX, h: maxY - minY, points };
}
/** Mirrors a canonical (unmirrored) panel's x coordinates about x=L,
 * matching the `1 - xFrac - wFrac` convention the rest of this file uses
 * for the passenger side. */
function mirrorPanel(panel, lengthIn) {
    const mirrored = { ...panel, x: lengthIn - panel.x - panel.w };
    if (panel.points)
        mirrored.points = panel.points.map(([x, y]) => [lengthIn - x, y]);
    return mirrored;
}
/** The upper-body profile points with the nose/tail bottom pinned to the
 * sill line (see SideProfile's doc comment), in canonical (unmirrored,
 * front=0) inches. */
function canonicalUpperPoints(profile, archetype, lengthIn, heightIn) {
    const sill = sillY(archetype, heightIn);
    return profile.points.map((p, i) => ({
        x: p.xFrac * lengthIn,
        y: i === 0 || i === profile.points.length - 1 ? sill : p.yFrac * heightIn,
    }));
}
/** Builds the side-view body outline points: the upper profile from the
 * archetype's key points (nose/tail pinned to the sill line), then the
 * sill line itself with wheel-arch cut-outs, forming a single closed
 * polygon of straight segments. */
function buildSideBodyPoints(template, mirror) {
    const { lengthIn: L, heightIn: H } = template.overall;
    const profile = SIDE_PROFILES[template.archetype];
    const canonical = canonicalUpperPoints(profile, template.archetype, L, H);
    const upperPoints = mirror ? canonical.map((p) => ({ x: L - p.x, y: p.y })) : canonical;
    const wheels = sideWheels(template, mirror);
    const sill = sillY(template.archetype, H);
    const bottomAscending = traceBaselineWithArches(sill, 0, L, wheels, ARCH_RADIUS_MULT);
    // Unmirrored: upper profile runs nose(x=0) -> tail(x=L) ascending, so the
    // bottom edge must run tail -> nose (descending) to close the loop.
    // Mirrored: upper profile runs nose(x=L) -> tail(x=0) descending, so the
    // bottom edge (tail x=0 -> nose x=L) is already ascending.
    const bottomPoints = mirror ? bottomAscending : [...bottomAscending].reverse();
    return [...upperPoints, ...bottomPoints];
}
function buildSideBody(template, mirror) {
    return pointsToPath(buildSideBodyPoints(template, mirror), true);
}
function buildSideGlass(template, mirror) {
    const { lengthIn: L, heightIn: H } = template.overall;
    const profile = SIDE_PROFILES[template.archetype];
    const mirrorX = (xFrac) => (mirror ? 1 - xFrac : xFrac) * L;
    const top = profile.glassTopFrac * H;
    const bottom = beltlineY(template.archetype, H);
    const piece = (startFrac, endFrac) => {
        const x1 = mirrorX(startFrac);
        const x2 = mirrorX(endFrac);
        const left = Math.min(x1, x2);
        const right = Math.max(x1, x2);
        return pointsToPath([
            { x: left, y: bottom },
            { x: left + (right - left) * 0.1, y: top },
            { x: right - (right - left) * 0.1, y: top },
            { x: right, y: bottom },
        ], true);
    };
    const pieces = [piece(profile.glassFrontXFrac.start, profile.glassFrontXFrac.end)];
    if (profile.glassRearXFrac)
        pieces.push(piece(profile.glassRearXFrac.start, profile.glassRearXFrac.end));
    return pieces;
}
/** Linear-interpolated y (inches) of the upper body profile at a canonical
 * (unmirrored, front=0) x, in inches - the nose/tail ends are pinned to the
 * sill line, matching the actual body outline. */
function upperBodyYAt(xIn, profile, archetype, lengthIn, heightIn) {
    const pts = canonicalUpperPoints(profile, archetype, lengthIn, heightIn);
    const x = Math.max(0, Math.min(lengthIn, xIn));
    for (let i = 0; i < pts.length - 1; i++) {
        const a = pts[i];
        const b = pts[i + 1];
        if (a && b && x >= a.x && x <= b.x) {
            const span = b.x - a.x || 1;
            const t = (x - a.x) / span;
            return a.y + (b.y - a.y) * t;
        }
    }
    const first = pts[0];
    const last = pts[pts.length - 1];
    return x < (first?.x ?? 0) ? (first?.y ?? 0) : (last?.y ?? 0);
}
/** Highest (smallest-y, most restrictive) upper-body boundary sampled across
 * a canonical x-range, used to keep a panel's top edge under the body. */
function maxUpperBodyY(x0, x1, profile, archetype, lengthIn, heightIn) {
    const samples = 5;
    let maxY = -Infinity;
    for (let i = 0; i <= samples; i++) {
        const x = x0 + ((x1 - x0) * i) / samples;
        maxY = Math.max(maxY, upperBodyYAt(x, profile, archetype, lengthIn, heightIn));
    }
    return maxY;
}
// The door bay (between the front and rear wheel arches) split front-to-rear
// into printable segments, in canonical (unmirrored) order. A van's cab
// door is short; the rest of the bay is solid cargo-side sheet metal with
// no glass, so it is split off as its own full-height segment.
const DOOR_BAY_SEGMENTS = {
    sedan: [
        { key: 'front_door', label: 'Front door', fracOfBay: 0.5 },
        { key: 'rear_door', label: 'Rear door', fracOfBay: 0.5 },
    ],
    hatch: [
        { key: 'front_door', label: 'Front door', fracOfBay: 0.48 },
        { key: 'rear_door', label: 'Rear door', fracOfBay: 0.52 },
    ],
    suv: [
        { key: 'front_door', label: 'Front door', fracOfBay: 0.45 },
        { key: 'rear_door', label: 'Rear door', fracOfBay: 0.55 },
    ],
    coupe: [{ key: 'front_door', label: 'Front door', fracOfBay: 1 }],
    pickup: [
        { key: 'front_door', label: 'Front door', fracOfBay: 0.5 },
        { key: 'cab_rear_door', label: 'Cab rear door', fracOfBay: 0.5 },
    ],
    van: [
        { key: 'front_door', label: 'Front door', fracOfBay: 0.25 },
        { key: 'cargo_side', label: 'Cargo side', fracOfBay: 0.75, fullHeight: true },
    ],
};
// The panel over the rear wheel arch (symmetric to front_fender), keyed per
// archetype to keep the historically-used names (bed_side for pickup,
// rear_quarter for everything with a trunk/hatch/cargo area behind the cab).
// `fullHeight` (van only) means there is no glass or pillar above the
// beltline there - it is solid metal up to the roofline, so the top follows
// the body instead of being capped at the beltline.
const REAR_ARCH_PANEL = {
    sedan: { key: 'rear_quarter', label: 'Rear quarter panel' },
    coupe: { key: 'rear_quarter', label: 'Rear quarter panel' },
    hatch: { key: 'rear_quarter', label: 'Rear quarter panel' },
    suv: { key: 'rear_quarter', label: 'Rear quarter panel' },
    pickup: { key: 'bed_side', label: 'Bed side' },
    // Van's door bay already has its own 'cargo_side' segment (see
    // DOOR_BAY_SEGMENTS) - this one, over the rear arch, needs a distinct key
    // since panel keys must be unique per view.
    van: { key: 'cargo_side_rear', label: 'Cargo side (rear)', fullHeight: true },
};
/** Builds the printable side panels for one side, derived directly from the
 * same body/wheel geometry as buildVehicleOutline: every panel sits inside
 * the body silhouette, clears the wheel arches with a safety margin, and
 * clears the door glass. One entry per real body panel - a curved edge
 * (a fender around a wheel arch, a sloped hood/trunk edge) is captured by
 * that single panel's `points` polygon rather than several small rects.
 * Built in canonical (unmirrored, front=0) space and mirrored as a whole
 * for the passenger side via mirrorPanel(). */
function buildSidePanels(template, view) {
    const mirror = view === 'passenger_side';
    const { lengthIn: L, heightIn: H } = template.overall;
    const profile = SIDE_PROFILES[template.archetype];
    const archetype = template.archetype;
    const canonicalWheels = sideWheels(template, false);
    const front = canonicalWheels[0];
    const rear = canonicalWheels[1];
    if (!front || !rear)
        return [];
    const sill = sillY(archetype, H);
    const frontArchR = front.r * ARCH_RADIUS_MULT;
    const rearArchR = rear.r * ARCH_RADIUS_MULT;
    const frontArchLeadX = front.cx - frontArchR;
    const frontArchTrailX = front.cx + frontArchR;
    const rearArchLeadX = rear.cx - rearArchR;
    const rearArchTrailX = rear.cx + rearArchR;
    const glassBottomY = beltlineY(archetype, H);
    // Any x whose column falls under a glass piece must stop at the beltline
    // there (the space above it is the window, not metal), even though the
    // body profile itself carries on up to the roof.
    const glassRangesIn = [
        { start: profile.glassFrontXFrac.start * L, end: profile.glassFrontXFrac.end * L },
        ...(profile.glassRearXFrac ? [{ start: profile.glassRearXFrac.start * L, end: profile.glassRearXFrac.end * L }] : []),
    ];
    // Widened by a couple inches on each side of the actual glass, so a door
    // that continues a little past the glass (into the pillar next to it)
    // does not rise sharply right at the window's edge - it settles into
    // that rise gradually, once clear of the pillar too.
    const isUnderGlassAt = (x) => glassRangesIn.some((g) => x > g.start - 2 && x < g.end + 2);
    const bodyTopAt = (x) => upperBodyYAt(x, profile, archetype, L, H);
    // A door's (or any glazed panel's) top: the body boundary, but never
    // higher than the beltline where there is actually glass above it.
    const doorTopAt = (x) => (isUnderGlassAt(x) ? Math.max(bodyTopAt(x), glassBottomY) : bodyTopAt(x)) + PANEL_SAFETY_IN;
    // A windowless panel's (van cargo side) top: follows the body/roofline
    // everywhere, ignoring glass entirely.
    const fullHeightTopAt = (x) => bodyTopAt(x) + PANEL_SAFETY_IN;
    // A wheel's arch cut-out, as a bottom-edge function with the sill as the
    // fallback outside the arch's own chord.
    const archBottomAt = (wheel) => (x) => {
        const curve = archCurveYAt(wheel, ARCH_RADIUS_MULT, x);
        // Never below the sill itself - the outline (traceBaselineWithArches)
        // clamps the same way, since the arch's chord can extend a little past
        // where the cut-out actually reaches the flat sill line.
        return Math.min(curve === Infinity ? sill : curve, sill) - PANEL_SAFETY_IN;
    };
    const doorBottom = sill - ROCKER_THICKNESS_IN - 0.3;
    const fullBottom = sill - PANEL_SAFETY_IN * 0.5;
    const canonicalPanels = [];
    const addRect = (key, label, x, w, y, h) => {
        if (w <= 0.5 || h <= 0.5)
            return;
        canonicalPanels.push({ key, label, view, x, y, w, h });
    };
    const addPoly = (key, label, x0, x1, topFn, bottomFn) => {
        const panel = buildPolygonPanel(key, label, view, x0, x1, topFn, bottomFn);
        if (panel)
            canonicalPanels.push(panel);
    };
    // Scans inward from a body tip (x=0 for the nose, x=L for the tail, which
    // both pinch to a single point at the sill) toward a boundary, looking
    // for the first x where the body has risen enough to fit `targetTop`.
    // Used so the bumper corner panels (flat rects) can run full height
    // without their tip-most corner landing outside the (pointed) nose/tail,
    // and so the hood/trunk-side polygons can start from a point that is
    // genuinely ON the body boundary rather than an invented pinch point.
    const scanFromTip = (targetTop, tipX, boundaryX) => {
        const step = tipX < boundaryX ? 0.5 : -0.5;
        let x = tipX;
        while (tipX < boundaryX ? x < boundaryX : x > boundaryX) {
            if (bodyTopAt(x) <= targetTop)
                return x;
            x += step;
        }
        return boundaryX;
    };
    // Front fender: spans the front wheel arch, flat top at the hood/belt
    // line, bottom edge sampled from the arch cut-out's own curve.
    const fenderX0 = Math.max(0, frontArchLeadX - PANEL_SAFETY_IN);
    const fenderX1 = frontArchTrailX + PANEL_SAFETY_IN;
    const fenderTop = Math.max(maxUpperBodyY(fenderX0, fenderX1, profile, archetype, L, H), glassBottomY) + PANEL_SAFETY_IN;
    addPoly('front_fender', 'Front fender', fenderX0, fenderX1, () => fenderTop, archBottomAt(front));
    // Front bumper corner: nose to the fender, running the full height from
    // the sill up to about the fender's own top (roughly the headlight
    // line).
    const bumperFrontEnd = fenderX0;
    const bumperFrontStart = scanFromTip(fenderTop, 0, bumperFrontEnd);
    addRect('front_bumper_side', 'Front bumper (side)', bumperFrontStart, bumperFrontEnd - bumperFrontStart, fenderTop, fullBottom - fenderTop);
    // Hood (side): the sloped hood surface above the bumper/fender, from
    // where that (slightly inset) height first becomes available to the end
    // of the fender - real printable sheet metal, not glass, that a
    // flat-topped panel would otherwise miss. Its own start is scanned
    // against the same inset top it actually uses, not the bumper's, so its
    // first vertex is genuinely on the body boundary rather than just above
    // it.
    const hoodSideTop = (x) => Math.min(doorTopAt(x), fenderTop - 0.15);
    const hoodSideStart = scanFromTip(fenderTop - 0.15, 0, bumperFrontEnd);
    addPoly('hood_side', 'Hood (side)', hoodSideStart, fenderX1, hoodSideTop, () => fenderTop);
    // Door bay: the flat region between the two arches, split front-to-rear
    // into one polygon per real door (or per windowless segment).
    const bayStart = frontArchTrailX + PANEL_SAFETY_IN;
    const bayEnd = rearArchLeadX - PANEL_SAFETY_IN;
    const bayWidth = Math.max(0, bayEnd - bayStart);
    const segments = DOOR_BAY_SEGMENTS[archetype];
    const fracTotal = segments.reduce((sum, s) => sum + s.fracOfBay, 0) || 1;
    const glassEndXs = [profile.glassFrontXFrac.end * L, profile.glassRearXFrac ? profile.glassRearXFrac.end * L : null].filter((x) => x !== null);
    let cursor = bayStart;
    let firstSegX0 = bayStart;
    let firstSegX1 = bayStart;
    for (let i = 0; i < segments.length; i++) {
        const segment = segments[i];
        if (!segment)
            continue;
        // The last segment always fills the remainder of the bay, so an
        // earlier segment extending past its fair share (see below) never
        // leaves a gap or an overlap at the end of the bay.
        let segX1 = i === segments.length - 1 ? bayEnd : cursor + (bayWidth * segment.fracOfBay) / fracTotal;
        // A windowed segment immediately followed by a windowless (fullHeight)
        // one must extend past any glass end that falls inside it, so the next
        // segment's full-height top never cuts into that glass.
        if (!segment.fullHeight && segments[i + 1]?.fullHeight) {
            for (const glassEnd of glassEndXs) {
                if (glassEnd > cursor && glassEnd < bayEnd)
                    segX1 = Math.max(segX1, glassEnd + PANEL_SAFETY_IN);
            }
            segX1 = Math.min(segX1, bayEnd);
        }
        const segX0 = cursor;
        if (i === 0) {
            firstSegX0 = segX0;
            firstSegX1 = segX1;
        }
        addPoly(segment.key, segment.label, segX0, segX1, segment.fullHeight ? fullHeightTopAt : doorTopAt, () => doorBottom);
        cursor = segX1;
    }
    // Rear arch panel (rear_quarter / bed_side / cargo_side_rear): spans the
    // rear wheel arch, symmetric to front_fender. `fullHeight` (van) lets the
    // top follow the roofline instead of being capped at the beltline, since
    // there is no glass or pillar over a van's cargo side.
    const rearPanelX0 = rearArchLeadX - PANEL_SAFETY_IN;
    const rearPanelX1 = rearArchTrailX + PANEL_SAFETY_IN;
    const rearPanelDef = REAR_ARCH_PANEL[archetype];
    const rearPanelBodyTop = maxUpperBodyY(rearPanelX0, rearPanelX1, profile, archetype, L, H);
    const rearPanelTop = (rearPanelDef.fullHeight ? rearPanelBodyTop : Math.max(rearPanelBodyTop, glassBottomY)) + PANEL_SAFETY_IN;
    addPoly(rearPanelDef.key, rearPanelDef.label, rearPanelX0, rearPanelX1, () => rearPanelTop, archBottomAt(rear));
    // Rear bumper corner: rear arch to the tail, running the full height from
    // the sill up to about the rear arch panel's own top - symmetric to the
    // front bumper corner, scanning inward from the (pointed) tail.
    const bumperRearStart = rearPanelX1;
    const bumperRearEnd = scanFromTip(rearPanelTop, L, bumperRearStart);
    addRect('rear_bumper_side', 'Rear bumper (side)', bumperRearStart, bumperRearEnd - bumperRearStart, rearPanelTop, fullBottom - rearPanelTop);
    // Trunk / tailgate (side): the sloped deck surface above the rear arch
    // panel/bumper, symmetric to hood_side. A van's cargo side is already
    // fullHeight (near the roofline), so this mostly matters for the other
    // archetypes' trunk/hatch/tailgate slope. Its own end is scanned against
    // the same inset top it actually uses (see hood_side).
    const trunkSideTop = (x) => Math.min(doorTopAt(x), rearPanelTop - 0.15);
    const trunkSideEnd = scanFromTip(rearPanelTop - 0.15, L, bumperRearStart);
    addPoly('trunk_side', 'Trunk / tailgate (side)', rearPanelX0, trunkSideEnd, trunkSideTop, () => rearPanelTop);
    // Rocker/sill strip, underneath the doors, between the two arches.
    addRect('rocker', 'Rocker panel', bayStart, bayEnd - bayStart, sill - ROCKER_THICKNESS_IN, ROCKER_THICKNESS_IN - 0.3);
    // Mirror trim - a small rect fully inside the first door-bay segment's
    // top-left corner, so it is trivially inside the body and clear of
    // glass. The one panel allowed to overlap another. Sized against the
    // door's own top/bottom functions evaluated right at its front edge
    // (not its polygon's bbox, which - for a door with a curved top - can
    // peak at a very different x than where the mirror actually sits).
    const firstSegment = segments[0];
    if (firstSegment && firstSegX1 - firstSegX0 > 1) {
        const mw = Math.min((firstSegX1 - firstSegX0) * 0.3, 6);
        const topAt = firstSegment.fullHeight ? fullHeightTopAt : doorTopAt;
        const mirrorTop = Math.max(topAt(firstSegX0), topAt(firstSegX0 + mw)) + 1;
        const mh = Math.min((doorBottom - mirrorTop) * 0.3, 4);
        if (mw > 0.5 && mh > 0.5) {
            canonicalPanels.push({ key: 'mirror', label: 'Mirror', view, x: firstSegX0, y: mirrorTop, w: mw, h: mh });
        }
    }
    return mirror ? canonicalPanels.map((p) => mirrorPanel(p, L)) : canonicalPanels;
}
// Tyre width seen head-on, in inches - real-world tyre widths, a little
// wider for the taller/heavier archetypes.
const TYRE_WIDTH_IN_BY_ARCHETYPE = {
    sedan: 10,
    coupe: 10,
    hatch: 10,
    suv: 11,
    pickup: 11,
    van: 11,
};
// Track (the distance between the centres of the left and right tyres) as a
// fraction of overall width - keeps the outer tyre edge a little inside the
// body's own outer edge.
const TRACK_FRAC_OF_WIDTH = 0.86;
/** Tyre centre x-positions and width for a front/rear view. */
function frontRearTyreLayout(template, view) {
    const dims = template.views[view] ?? { widthIn: template.overall.widthIn, heightIn: template.overall.heightIn };
    const track = dims.widthIn * TRACK_FRAC_OF_WIDTH;
    const centerX = dims.widthIn / 2;
    return { cxLeft: centerX - track / 2, cxRight: centerX + track / 2, widthIn: TYRE_WIDTH_IN_BY_ARCHETYPE[template.archetype] };
}
// Front/rear view geometry shared between the body outline, glass and panel
// layout (buildFrontRearBody, buildFrontRearGlass, buildFrontRearPanels) so
// the panel layout can never drift out of sync with what is actually drawn.
const FRONT_REAR_SHOULDER_FRAC = 0.06;
const FRONT_REAR_BODY_TOP_FRAC = 0.08;
const FRONT_REAR_GLASS_TOP_FRAC = 0.12;
const FRONT_REAR_GLASS_BOTTOM_FRAC = 0.3;
function buildFrontRearBody(template, view) {
    const dims = template.views[view] ?? { widthIn: template.overall.widthIn, heightIn: template.overall.heightIn };
    const { widthIn: W, heightIn: H } = dims;
    const shoulder = W * FRONT_REAR_SHOULDER_FRAC;
    const bumper = bumperY(template.archetype, H);
    // A straight bumper line - no wheel-arch notches (seen head-on the tyres
    // stand in front of/behind the bumper, not cut into it).
    return pointsToPath([
        { x: shoulder, y: H * FRONT_REAR_BODY_TOP_FRAC },
        { x: W - shoulder, y: H * FRONT_REAR_BODY_TOP_FRAC },
        { x: W - shoulder, y: bumper },
        { x: shoulder, y: bumper },
    ], true);
}
function buildFrontRearGlass(template, view) {
    const dims = template.views[view] ?? { widthIn: template.overall.widthIn, heightIn: template.overall.heightIn };
    const { widthIn: W, heightIn: H } = dims;
    return pointsToPath([
        { x: W * 0.16, y: H * FRONT_REAR_GLASS_TOP_FRAC },
        { x: W * 0.84, y: H * FRONT_REAR_GLASS_TOP_FRAC },
        { x: W * 0.76, y: H * FRONT_REAR_GLASS_BOTTOM_FRAC },
        { x: W * 0.24, y: H * FRONT_REAR_GLASS_BOTTOM_FRAC },
    ], true);
}
/** The headlight/tail-light/grille/plate exclusion rects for a front or
 * rear view, in that view's own inch coordinates. Shared by the outline
 * drawing (buildFrontRearLights/Trim) and the panel exclusion logic in
 * buildFrontRearPanels, so a panel can never print over a light. */
function frontRearFeatureRects(template, view) {
    const dims = template.views[view] ?? { widthIn: template.overall.widthIn, heightIn: template.overall.heightIn };
    const { widthIn: W, heightIn: H } = dims;
    const features = getFeatures(template);
    const lightSpec = view === 'front' ? features.headlight : features.taillight;
    const centerX = W / 2;
    // The body's own left/right edges in a front/rear view (see
    // buildFrontRearBody's `shoulder`) - a light/trim rect must stay inside
    // this range at every height, since the body is a constant-width shape
    // (only its bottom edge varies, for the wheel arches).
    const shoulder = W * FRONT_REAR_SHOULDER_FRAC;
    const bodyX0 = shoulder + 0.2;
    const bodyX1 = W - shoulder - 0.2;
    const bodyTopY = H * FRONT_REAR_BODY_TOP_FRAC + 0.2;
    const bumper = bumperY(template.archetype, H);
    // The body's own bottom boundary - a straight bumper line (no wheel-arch
    // notches in a front/rear view).
    const bodyBottomAt = () => bumper - 0.2;
    // Slide a rect inward (never shrink it) so it lies fully within
    // [bodyX0, bodyX1] - a rect wider than that range is centered instead.
    const clampX = (rect) => {
        const width = rect.x1 - rect.x0;
        if (width >= bodyX1 - bodyX0)
            return { ...rect, x0: bodyX0, x1: bodyX1 };
        let x0 = rect.x0;
        let x1 = rect.x1;
        if (x0 < bodyX0) {
            x1 += bodyX0 - x0;
            x0 = bodyX0;
        }
        if (x1 > bodyX1) {
            x0 -= x1 - bodyX1;
            x1 = bodyX1;
        }
        return { ...rect, x0, x1 };
    };
    // Slide a rect UP (never shrink it) so its bottom clears the bumper line
    // and its top stays below the body's own top edge.
    const clampY = (rect) => {
        const height = rect.y1 - rect.y0;
        const minBottom = bodyBottomAt();
        let y1 = rect.y1;
        let y0 = rect.y0;
        if (y1 > minBottom) {
            y0 -= y1 - minBottom;
            y1 = minBottom;
        }
        if (y0 < bodyTopY) {
            y0 = bodyTopY;
            y1 = y0 + height;
        }
        return { ...rect, y0, y1 };
    };
    const clampRect = (rect) => clampY(clampX(rect));
    const lightRect = (cx) => {
        const y1 = H - lightSpec.bottomFromGroundIn;
        return clampRect({ x0: cx - lightSpec.widthIn / 2, y0: y1 - lightSpec.heightIn, x1: cx + lightSpec.widthIn / 2, y1 });
    };
    const lights = [lightRect(centerX - lightSpec.centerFromCenterlineIn), lightRect(centerX + lightSpec.centerFromCenterlineIn)];
    const trim = [];
    // The grille sits only at the front of the vehicle - the rear has no
    // equivalent (its trim is the plate recess only).
    if (view === 'front') {
        const grilleY1 = H - features.grille.bottomFromGroundIn;
        trim.push(clampRect({ x0: centerX - features.grille.widthIn / 2, y0: grilleY1 - features.grille.heightIn, x1: centerX + features.grille.widthIn / 2, y1: grilleY1 }));
    }
    const plate = view === 'front' ? features.frontPlate : features.rearPlate;
    if (plate) {
        const plateY1 = H - plate.bottomFromGroundIn;
        trim.push(clampRect({ x0: centerX - plate.widthIn / 2, y0: plateY1 - plate.heightIn, x1: centerX + plate.widthIn / 2, y1: plateY1 }));
    }
    return { lights, trim };
}
function buildFrontRearLights(template, view) {
    return frontRearFeatureRects(template, view).lights.map((r) => pointsToPath([
        { x: r.x0, y: r.y0 },
        { x: r.x1, y: r.y0 },
        { x: r.x1, y: r.y1 },
        { x: r.x0, y: r.y1 },
    ], true));
}
function buildFrontRearTrim(template, view) {
    return frontRearFeatureRects(template, view).trim.map((r) => pointsToPath([
        { x: r.x0, y: r.y0 },
        { x: r.x1, y: r.y0 },
        { x: r.x1, y: r.y1 },
        { x: r.x0, y: r.y1 },
    ], true));
}
/** Front/rear tyres, drawn as tall narrow rounded rects (seen head-on a
 * tyre is not a circle) - width a fixed real-world tyre width, height from
 * the ground up to a little above the body's own lower edge there (the
 * same arch cut-out the outline itself is clipped to). */
function buildFrontRearTyres(template, view) {
    const dims = template.views[view] ?? { widthIn: template.overall.widthIn, heightIn: template.overall.heightIn };
    const { widthIn: W, heightIn: H } = dims;
    const bumper = bumperY(template.archetype, H);
    const { cxLeft, cxRight, widthIn } = frontRearTyreLayout(template, view);
    // Standing on the ground (bottom = view bottom), visible top just under
    // the bumper line (the body is drawn over the tyre, so it only needs to
    // poke a little above that line).
    const top = bumper - 1;
    return [cxLeft, cxRight].map((cx) => {
        const x = Math.max(0, Math.min(cx - widthIn / 2, W - widthIn));
        return { x, y: top, w: widthIn, h: H - top, r: widthIn * 0.25 };
    });
}
/** Merges a list of feature rects' x-ranges (already grown by clearance,
 * clipped to [x0,x1]) into non-overlapping, sorted intervals. */
function mergeXIntervals(rects, x0, x1) {
    const clipped = rects
        .map((r) => ({ x0: Math.max(x0, r.x0), x1: Math.min(x1, r.x1) }))
        .filter((r) => r.x1 > r.x0)
        .sort((a, b) => a.x0 - b.x0);
    const merged = [];
    for (const c of clipped) {
        const last = merged[merged.length - 1];
        if (last && c.x0 <= last.x1) {
            last.x1 = Math.max(last.x1, c.x1);
        }
        else {
            merged.push({ ...c });
        }
    }
    return merged;
}
/** The [x0,x1] gaps left over in [x0,x1] once `merged` (sorted,
 * non-overlapping) is carved out - the outer corners plus every gap between
 * consecutive exclusions. */
function complementIntervals(merged, x0, x1) {
    const out = [];
    let cursor = x0;
    for (const m of merged) {
        if (m.x0 > cursor)
            out.push({ x0: cursor, x1: m.x0 });
        cursor = Math.max(cursor, m.x1);
    }
    if (x1 > cursor)
        out.push({ x0: cursor, x1 });
    return out;
}
/** Two x-intervals "overlap" enough to be considered the same paintable
 * region as it continues from one horizontal band into the next. */
function xOverlaps(a, b) {
    return Math.min(a.x1, b.x1) - Math.max(a.x0, b.x0) > 0.05;
}
/** A stack of same-column rects (one per horizontal band it survives
 * across), building up to either a plain rect (every rect has the same
 * x-range) or a stepped polygon panel once the surviving width changes
 * from one band to the next (e.g. a corner that's narrow beside a light
 * and widens once the light ends). */
function faceGroupToPanel(key, label, view, rects) {
    const minX = Math.min(...rects.map((r) => r.x0));
    const maxX = Math.max(...rects.map((r) => r.x1));
    const minY = Math.min(...rects.map((r) => r.y0));
    const maxY = Math.max(...rects.map((r) => r.y1));
    const allSameWidth = rects.every((r) => Math.abs(r.x0 - minX) < 0.05 && Math.abs(r.x1 - maxX) < 0.05);
    if (allSameWidth) {
        return { key, label, view, x: minX, y: minY, w: maxX - minX, h: maxY - minY };
    }
    // A staircase: walk the left edge top-to-bottom, then the right edge
    // bottom-to-top - always a valid simple orthogonal polygon since the
    // rects are y-contiguous (each one's y1 equals the next one's y0).
    const sorted = [...rects].sort((a, b) => a.y0 - b.y0);
    const left = [];
    const right = [];
    for (const r of sorted) {
        left.push([r.x0, r.y0], [r.x0, r.y1]);
        right.push([r.x1, r.y0], [r.x1, r.y1]);
    }
    const points = [...left, ...right.reverse()];
    return { key, label, view, x: minX, y: minY, w: maxX - minX, h: maxY - minY, points };
}
/** Builds the front/rear panel set: the face is covered everywhere except
 * the lights/grille/plate (plus a clearance margin) - see the coordinator
 * spec this was written against for the exact requirements (no gaps left
 * uncovered, slivers merged into a neighbour, semantic non-numeric keys).
 *
 * Works by slicing the face into fine horizontal bands at every
 * (clearance-grown) exclusion edge, computing the surviving x-gaps in each
 * band (the outer corners, and the gaps between adjacent exclusions), then
 * grouping bands vertically wherever a gap in one band visibly continues
 * into the next (by x-overlap, not requiring an exact width match) into a
 * single panel - a plain rect if the width never changes, a stepped
 * polygon otherwise (e.g. a corner that's narrow beside a light and wider
 * once the light ends). Bands thinner than the minimum are merged into a
 * neighbouring band first so no sliver panel is ever produced. */
function buildFrontRearPanels(template, view) {
    const dims = template.views[view] ?? { widthIn: template.overall.widthIn, heightIn: template.overall.heightIn };
    const { widthIn: W, heightIn: H } = dims;
    // Clearance kept from the body's own edges (top/bottom/sides) - much
    // tighter than the old fixed margins, since these edges are the body's
    // real boundary (see buildFrontRearBody/buildFrontRearGlass), not a
    // guess.
    const EDGE_CLEARANCE_IN = 0.5;
    const bodyTop = H * FRONT_REAR_BODY_TOP_FRAC + EDGE_CLEARANCE_IN;
    const glassTop = H * FRONT_REAR_GLASS_TOP_FRAC - EDGE_CLEARANCE_IN;
    const glassBottom = H * FRONT_REAR_GLASS_BOTTOM_FRAC;
    // The hood/tailgate face starts right below the windshield/rear glass
    // (derived from the same geometry buildFrontRearGlass draws), not a fixed
    // fraction of the body's height.
    const top = glassBottom + EDGE_CLEARANCE_IN;
    const bumper = bumperY(template.archetype, H);
    // The bumper line, seen head-on, is straight - no wheel-arch cut-outs to
    // route around. The printable area now runs down through the
    // bumper/lower valance to the body's own bottom edge.
    const bottom = bumper - EDGE_CLEARANCE_IN;
    // The body's own shoulder sits at FRONT_REAR_SHOULDER_FRAC*W (see
    // buildFrontRearBody) - stay just inside it rather than a wider margin.
    const shoulder = W * FRONT_REAR_SHOULDER_FRAC;
    const x0 = shoulder + EDGE_CLEARANCE_IN;
    const x1 = W - shoulder - EDGE_CLEARANCE_IN;
    const margin = 0.5;
    const MIN_SPAN = 3; // no panel dimension smaller than this (a "sliver")
    const upperKey = view === 'front' ? 'hood_face' : 'tailgate_or_trunk';
    const upperLabel = view === 'front' ? 'Hood face' : 'Tailgate / trunk';
    const bumperKey = view === 'front' ? 'front_bumper' : 'rear_bumper';
    const bumperLabel = view === 'front' ? 'Front bumper' : 'Rear bumper';
    const cornerKeyPrefix = view === 'front' ? 'front_corner' : 'rear_corner';
    const cornerLabelPrefix = view === 'front' ? 'Front corner' : 'Rear corner';
    const centerKeyPrefix = view === 'front' ? 'front_center' : 'rear_center';
    const centerLabelPrefix = view === 'front' ? 'Front center' : 'Rear center';
    // The painted body above the windshield/rear glass (a roof cap/header
    // strip) - independent of the light/grille exclusion bands below, since
    // nothing in DEFAULT_FEATURES_BY_ARCHETYPE reaches this high.
    const headerPanels = [];
    if (glassTop - bodyTop > 0.5 && x1 - x0 > 0.5) {
        headerPanels.push({
            key: view === 'front' ? 'roof_cap_front' : 'roof_cap_rear',
            label: view === 'front' ? 'Roof cap (front)' : 'Roof cap (rear)',
            view,
            x: x0,
            y: bodyTop,
            w: x1 - x0,
            h: glassTop - bodyTop,
        });
    }
    if (x1 - x0 <= 0.5 || bottom - top <= 0.5)
        return headerPanels;
    // Every light/grille/plate rect, grown by the clearance margin on all
    // four sides - the exclusion zone a panel must stay clear of.
    const grown = [...frontRearFeatureRects(template, view).lights, ...frontRearFeatureRects(template, view).trim].map((r) => ({
        x0: r.x0 - margin,
        x1: r.x1 + margin,
        y0: r.y0 - margin,
        y1: r.y1 + margin,
    }));
    // Y-boundaries at every exclusion's (clamped) top/bottom edge, then
    // thin bands (shorter than MIN_SPAN) folded into the previous one so no
    // band is ever a sliver.
    const rawYs = Array.from(new Set([
        top,
        bottom,
        ...grown.flatMap((r) => [Math.max(top, Math.min(bottom, r.y0)), Math.max(top, Math.min(bottom, r.y1))]).filter((y) => y > top && y < bottom),
    ])).sort((a, b) => a - b);
    const yBoundaries = [rawYs[0]];
    for (let i = 1; i < rawYs.length; i++) {
        const y = rawYs[i];
        const isLast = i === rawYs.length - 1;
        if (!isLast && y - yBoundaries[yBoundaries.length - 1] < MIN_SPAN)
            continue;
        yBoundaries.push(y);
    }
    while (yBoundaries.length > 2 && yBoundaries[yBoundaries.length - 1] - yBoundaries[yBoundaries.length - 2] < MIN_SPAN) {
        yBoundaries.splice(yBoundaries.length - 2, 1);
    }
    // Per band: the surviving x-gaps (outer corners plus gaps between
    // exclusions active anywhere in that band).
    const bands = [];
    for (let i = 0; i < yBoundaries.length - 1; i++) {
        const y0 = yBoundaries[i];
        const y1 = yBoundaries[i + 1];
        if (y1 - y0 <= 0.05)
            continue;
        const active = grown.filter((r) => r.y0 < y1 - 0.01 && r.y1 > y0 + 0.01);
        const merged = mergeXIntervals(active, x0, x1);
        // Keep any non-trivial gap here, even one narrower than MIN_SPAN - a
        // narrow column (e.g. beside a light) can still be genuinely paintable
        // once it is grouped vertically with the same gap in neighbouring
        // bands. Only the closedGroups filter below drops a group that is
        // still a sliver in BOTH dimensions once grouping is done.
        const gaps = complementIntervals(merged, x0, x1).filter((g) => g.x1 - g.x0 >= 0.5);
        bands.push({ y0, y1, gaps });
    }
    let open = [];
    const closedGroups = [];
    for (const band of bands) {
        const claims = band.gaps.map((iv) => open.filter((o) => xOverlaps(o.interval, iv)));
        const stillOpen = [];
        band.gaps.forEach((iv, i) => {
            const candidates = claims[i];
            const uniquelyMatched = candidates.length === 1 && claims.every((c, j) => j === i || !c.includes(candidates[0]));
            if (uniquelyMatched) {
                const entry = candidates[0];
                entry.group.push({ x0: iv.x0, x1: iv.x1, y0: band.y0, y1: band.y1 });
                entry.interval = iv;
                stillOpen.push(entry);
            }
            else {
                const group = [{ x0: iv.x0, x1: iv.x1, y0: band.y0, y1: band.y1 }];
                stillOpen.push({ interval: iv, group });
            }
        });
        for (const o of open)
            if (!stillOpen.includes(o))
                closedGroups.push(o.group);
        open = stillOpen;
    }
    for (const o of open)
        closedGroups.push(o.group);
    // Drop any group whose total footprint is still a sliver in both
    // dimensions (nothing sensible to merge it into without ambiguity).
    const groups = closedGroups.filter((g) => {
        const w = Math.max(...g.map((r) => r.x1)) - Math.min(...g.map((r) => r.x0));
        const h = Math.max(...g.map((r) => r.y1)) - Math.min(...g.map((r) => r.y0));
        return w >= MIN_SPAN && h >= MIN_SPAN;
    });
    const centerX = (x0 + x1) / 2;
    const EDGE_TOL = 0.6;
    let cornerLeftN = 0;
    let cornerRightN = 0;
    let centerLeftN = 0;
    let centerRightN = 0;
    let hoodUsed = false;
    let bumperUsed = false;
    const ordinal = (n) => (n === 1 ? '_lower' : n === 2 ? '_lowest' : `_lower${n}`);
    const panels = groups
        .sort((a, b) => Math.min(...a.map((r) => r.y0)) - Math.min(...b.map((r) => r.y0)))
        .map((group) => {
        const minX = Math.min(...group.map((r) => r.x0));
        const maxX = Math.max(...group.map((r) => r.x1));
        const minY = Math.min(...group.map((r) => r.y0));
        const maxY = Math.max(...group.map((r) => r.y1));
        const touchesLeft = minX <= x0 + EDGE_TOL;
        const touchesRight = maxX >= x1 - EDGE_TOL;
        const touchesTop = minY <= top + EDGE_TOL;
        const touchesBottom = maxY >= bottom - EDGE_TOL;
        let key;
        let label;
        // A group touching exactly one side edge (not both) is a corner,
        // whatever else it touches. Otherwise, touching the top/bottom edge
        // is the strongest remaining signal for the main hood/tailgate (or
        // bumper) panel - even where it is not the full width the whole way
        // (e.g. a van's tall corner lights start right where the glass
        // margin ends, leaving no full-width strip above them: the widest
        // group that still reaches the top is the closest thing to "one big
        // panel above the lights").
        if (touchesLeft && !touchesRight) {
            cornerLeftN++;
            key = cornerLeftN === 1 ? `${cornerKeyPrefix}_left` : `${cornerKeyPrefix}_left${ordinal(cornerLeftN - 1)}`;
            label = cornerLeftN === 1 ? `${cornerLabelPrefix} (left)` : `${cornerLabelPrefix} (left, lower)`;
        }
        else if (touchesRight && !touchesLeft) {
            cornerRightN++;
            key = cornerRightN === 1 ? `${cornerKeyPrefix}_right` : `${cornerKeyPrefix}_right${ordinal(cornerRightN - 1)}`;
            label = cornerRightN === 1 ? `${cornerLabelPrefix} (right)` : `${cornerLabelPrefix} (right, lower)`;
        }
        else if (touchesTop && !hoodUsed) {
            hoodUsed = true;
            key = upperKey;
            label = upperLabel;
        }
        else if (touchesBottom && !bumperUsed) {
            bumperUsed = true;
            key = bumperKey;
            label = bumperLabel;
        }
        else if (minX + maxX < 2 * centerX) {
            centerLeftN++;
            key = centerLeftN === 1 ? `${centerKeyPrefix}_left` : `${centerKeyPrefix}_left${ordinal(centerLeftN - 1)}`;
            label = centerLeftN === 1 ? `${centerLabelPrefix} (left)` : `${centerLabelPrefix} (left, lower)`;
        }
        else {
            centerRightN++;
            key = centerRightN === 1 ? `${centerKeyPrefix}_right` : `${centerKeyPrefix}_right${ordinal(centerRightN - 1)}`;
            label = centerRightN === 1 ? `${centerLabelPrefix} (right)` : `${centerLabelPrefix} (right, lower)`;
        }
        return faceGroupToPanel(key, label, view, group);
    });
    return [...headerPanels, ...panels];
}
const TOP_VIEW_LAYOUT = {
    sedan: { hoodEndFrac: 0.38, roofEndFrac: 0.72, hasTrunk: true, hasRearGlass: true, bedExcluded: false },
    coupe: { hoodEndFrac: 0.42, roofEndFrac: 0.58, hasTrunk: true, hasRearGlass: true, bedExcluded: false },
    hatch: { hoodEndFrac: 0.4, roofEndFrac: 0.9, hasTrunk: false, hasRearGlass: true, bedExcluded: false },
    suv: { hoodEndFrac: 0.34, roofEndFrac: 0.9, hasTrunk: false, hasRearGlass: true, bedExcluded: false },
    pickup: { hoodEndFrac: 0.3, roofEndFrac: 0.5, hasTrunk: false, hasRearGlass: false, bedExcluded: true },
    van: { hoodEndFrac: 0.17, roofEndFrac: 0.95, hasTrunk: false, hasRearGlass: false, bedExcluded: false },
};
const TOP_VIEW_INSET_FRAC = 0.06;
const TOP_VIEW_NOSE_TAPER_FRAC = 0.05;
const TOP_VIEW_MIRROR_BUMP_IN = 2.5;
/** The plan-view body outline: a rounded rect tapered at the nose, with a
 * small mirror bump on each side roughly where the front doors are. */
function buildTopViewBody(template) {
    const { widthIn: W, lengthIn: L } = template.overall;
    const layout = TOP_VIEW_LAYOUT[template.archetype];
    const corner = Math.min(W, L) * 0.05;
    const taper = W * TOP_VIEW_NOSE_TAPER_FRAC;
    const mirrorY = layout.hoodEndFrac * L + L * 0.03;
    const bumpHalf = L * 0.02;
    return pointsToPath([
        { x: taper, y: 0 },
        { x: W - taper, y: 0 },
        { x: W, y: corner },
        { x: W, y: mirrorY - bumpHalf },
        { x: W + TOP_VIEW_MIRROR_BUMP_IN, y: mirrorY },
        { x: W, y: mirrorY + bumpHalf },
        { x: W, y: L - corner },
        { x: W - corner, y: L },
        { x: corner, y: L },
        { x: 0, y: L - corner },
        { x: 0, y: mirrorY + bumpHalf },
        { x: -TOP_VIEW_MIRROR_BUMP_IN, y: mirrorY },
        { x: 0, y: mirrorY - bumpHalf },
        { x: 0, y: corner },
    ], true);
}
/** Windshield and (when the archetype has one) rear glass, seen from above -
 * both trapezoids, narrower on the side facing the nearer body tip. */
function buildTopViewGlass(template) {
    const { widthIn: W, lengthIn: L } = template.overall;
    const layout = TOP_VIEW_LAYOUT[template.archetype];
    const inset = W * (TOP_VIEW_INSET_FRAC + 0.06);
    const depth = L * 0.05;
    const pieces = [];
    const windshieldY = layout.hoodEndFrac * L;
    pieces.push(pointsToPath([
        { x: inset * 1.6, y: windshieldY - depth },
        { x: W - inset * 1.6, y: windshieldY - depth },
        { x: W - inset, y: windshieldY },
        { x: inset, y: windshieldY },
    ], true));
    if (layout.hasRearGlass) {
        const rearY = layout.roofEndFrac * L;
        pieces.push(pointsToPath([
            { x: inset, y: rearY },
            { x: W - inset, y: rearY },
            { x: W - inset * 1.6, y: rearY + depth },
            { x: inset * 1.6, y: rearY + depth },
        ], true));
    }
    return pieces;
}
/** The plan-view panels: hood, roof (cab/cargo roof for a van/pickup), and
 * - sedan/coupe only - the deck lid behind the rear glass. A pickup's bed
 * floor is deliberately not a printable panel. */
function buildTopViewPanels(template) {
    const { widthIn: W, lengthIn: L } = template.overall;
    const layout = TOP_VIEW_LAYOUT[template.archetype];
    const insetX = W * TOP_VIEW_INSET_FRAC + Math.max(0, W * TOP_VIEW_NOSE_TAPER_FRAC - W * TOP_VIEW_INSET_FRAC);
    const glassMargin = L * 0.07;
    const view = 'roof';
    const panels = [];
    const addRect = (key, label, y0, y1) => {
        const h = y1 - y0;
        if (h <= 1)
            return;
        panels.push({ key, label, view, x: insetX, y: y0, w: W - insetX * 2, h });
    };
    addRect('hood', 'Hood', W * TOP_VIEW_INSET_FRAC, layout.hoodEndFrac * L - glassMargin);
    const roofEnd = layout.hasTrunk || layout.hasRearGlass ? layout.roofEndFrac * L - glassMargin : layout.roofEndFrac * L;
    addRect('roof', 'Roof', layout.hoodEndFrac * L + glassMargin, roofEnd);
    if (layout.hasTrunk) {
        addRect('trunk_top', 'Trunk lid', layout.roofEndFrac * L + glassMargin, L - L * TOP_VIEW_INSET_FRAC);
    }
    // The pickup bed floor (layout.bedExcluded) intentionally gets no panel.
    return panels;
}
// Bumped whenever this file's generator geometry changes in a way that
// matters for rebuilding a saved template server side (panel layout, body
// outline). A template saved before this field existed has no
// generatorVersion and counts as version 1. v3: 'roof' became the full
// plan (top) view (no separate 'hood' view), added lights/trim/tyres and
// the front/rear tyre-rect + feature-exclusion panel layout. v5: front/rear
// panels now cover the roof cap above the glass and run down through the
// bumper to the body's own edge, tighter clearances throughout, and the
// front_fender/rear arch side panels follow the roofline instead of being
// pinned to the beltline.
export const PRINT_TEMPLATE_GENERATOR_VERSION = 5;
/** Builds a builtin PrintTemplate for a size class, optionally overriding the
 * overall dims / archetype / door count (e.g. once a real trim's dims are
 * known via AI measurement), and the measured headlight/tail-light/grille/
 * plate geometry (falls back to an archetype default when omitted - see
 * getFeatures). Panels are derived from the same body/wheel geometry as
 * buildVehicleOutline (see buildSidePanels), so they always sit inside the
 * silhouette and clear of glass/lights/wheels. */
export function buildPrintTemplate(sizeClass, overall, archetypeOverride, doorsOverride, features) {
    const baseOverall = OVERALL_BY_SIZE_CLASS[sizeClass];
    const resolvedOverall = { ...baseOverall, ...overall };
    const archetype = archetypeOverride ?? ARCHETYPE_BY_SIZE_CLASS[sizeClass];
    const doors = doorsOverride ?? DOORS_BY_SIZE_CLASS[sizeClass];
    const { lengthIn: L, widthIn: W } = resolvedOverall;
    const template = {
        units: 'in',
        overall: resolvedOverall,
        archetype,
        doors,
        views: {
            driver_side: { widthIn: L, heightIn: resolvedOverall.heightIn },
            passenger_side: { widthIn: L, heightIn: resolvedOverall.heightIn },
            front: { widthIn: W, heightIn: resolvedOverall.heightIn },
            rear: { widthIn: W, heightIn: resolvedOverall.heightIn },
            // The full plan (top-down) view - hood + roof + trunk lid - front at
            // the top (y=0).
            roof: { widthIn: W, heightIn: L },
        },
        panels: [],
        notes: '',
        generatorVersion: PRINT_TEMPLATE_GENERATOR_VERSION,
        ...(features ? { features } : {}),
    };
    template.panels = [
        ...buildSidePanels(template, 'driver_side'),
        ...buildSidePanels(template, 'passenger_side'),
        ...buildFrontRearPanels(template, 'front'),
        ...buildFrontRearPanels(template, 'rear'),
        ...buildTopViewPanels(template),
    ];
    return template;
}
/** One builtin template per size class, built with each class's own typical
 * dims - the starting point before any vehicle-specific override. */
export const BUILTIN_PRINT_TEMPLATES = Object.fromEntries(Object.keys(OVERALL_BY_SIZE_CLASS).map((sizeClass) => [sizeClass, buildPrintTemplate(sizeClass)]));
/** The body's upper-surface y (inches from the top of the view box) at a
 * given x, in CANONICAL (unmirrored, nose at x=0) coordinates - found by
 * linearly interpolating the archetype's side profile points. Used to keep
 * the side-view light cut inside the body instead of floating off the
 * nose/tail. */
function sideUpperYAt(template, xCanonical) {
    const { lengthIn: L, heightIn: H } = template.overall;
    const profile = SIDE_PROFILES[template.archetype];
    const points = canonicalUpperPoints(profile, template.archetype, L, H);
    const x = Math.max(0, Math.min(L, xCanonical));
    for (let i = 0; i < points.length - 1; i++) {
        const a = points[i];
        const b = points[i + 1];
        if (!a || !b)
            continue;
        if (x >= a.x && x <= b.x) {
            if (b.x === a.x)
                return Math.min(a.y, b.y);
            const t = (x - a.x) / (b.x - a.x);
            return a.y + (b.y - a.y) * t;
        }
    }
    return points[points.length - 1]?.y ?? H;
}
/** A headlight/tail-light cut in a side view, at the same height as the
 * front/rear view's light (so the three views agree), shifted inward from
 * the nose/tail until the whole rect clears the body's own hood/fender
 * surface at that height (using sideUpperYAt) - a visual detail only (see
 * the class comment on buildSidePanels for why side panels do not need to
 * exclude it precisely: it sits within the already-scanned bumper/fender
 * margin). */
function buildSideLights(template, mirror) {
    const { lengthIn: L, heightIn: H } = template.overall;
    const features = getFeatures(template);
    const sill = sillY(template.archetype, H);
    const mirrorX = (x) => (mirror ? L - x : x);
    const topMargin = 0.4;
    const bottomMargin = 0.4;
    const searchStep = 0.25;
    const piece = (fromNose, spec) => {
        const heightSide = spec.heightIn;
        const depth = Math.min(heightSide * 0.6, L * 0.15);
        const centerY = H - (spec.bottomFromGroundIn + spec.heightIn / 2);
        const y0 = centerY - heightSide / 2;
        // Never let the rect's bottom edge sink through the sill.
        const y1 = Math.min(centerY + heightSide / 2, sill - bottomMargin);
        // Walk inward from the nose/tail tip until the body's own top surface
        // (hood/fender) clears the light's top edge - the point nearest the
        // nose/tail is the last to clear, so checking it is enough to
        // guarantee the whole rect (deeper into the body) also clears.
        let outerX = fromNose ? 0 : L;
        for (let d = 0; d <= L / 2; d += searchStep) {
            const x = fromNose ? d : L - d;
            outerX = x;
            if (sideUpperYAt(template, x) <= y0 - topMargin)
                break;
        }
        const x0Canonical = fromNose ? outerX : outerX - depth;
        const x1Canonical = fromNose ? outerX + depth : outerX;
        const xa = mirrorX(Math.max(0, Math.min(x0Canonical, L)));
        const xb = mirrorX(Math.max(0, Math.min(x1Canonical, L)));
        return pointsToPath([
            { x: Math.min(xa, xb), y: y0 },
            { x: Math.max(xa, xb), y: y0 },
            { x: Math.max(xa, xb), y: y1 },
            { x: Math.min(xa, xb), y: y1 },
        ], true);
    };
    return [piece(true, features.headlight), piece(false, features.taillight)];
}
/** Builds a rough, archetype-recognisable vehicle outline for one view,
 * used only for visual orientation in the placement editor (not for
 * measurement or pricing). Coordinates are in inches, in the view's own
 * coordinate box (origin top-left), matching template.views[view]. */
export function buildVehicleOutline(template, view) {
    if (view === 'driver_side' || view === 'passenger_side') {
        const mirror = view === 'passenger_side';
        return {
            body: buildSideBody(template, mirror),
            glass: buildSideGlass(template, mirror),
            lights: buildSideLights(template, mirror),
            trim: [],
            wheels: sideWheels(template, mirror),
            tyres: [],
        };
    }
    if (view === 'front' || view === 'rear') {
        return {
            body: buildFrontRearBody(template, view),
            glass: [buildFrontRearGlass(template, view)],
            lights: buildFrontRearLights(template, view),
            trim: buildFrontRearTrim(template, view),
            wheels: [],
            tyres: buildFrontRearTyres(template, view),
        };
    }
    // roof: the full plan (top-down) view.
    return {
        body: buildTopViewBody(template),
        glass: buildTopViewGlass(template),
        lights: [],
        trim: [],
        wheels: [],
        tyres: [],
    };
}
//# sourceMappingURL=templates.js.map